/* eslint-disable */
/* this file is generated by generateIcons script */

import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class DataSetIcon extends BaseIcon {
  getChildren = () => [ <g fill={ this.getColor() }>
    <rect width="1" height="4"/>
    <rect width="4" height="1"/>
    <rect x="15" width="1" height="4"/>
    <rect x="12" width="4" height="1"/>
    <rect y="12" width="1" height="4"/>
    <rect y="15" width="4" height="1"/>
    <rect x="15" y="12" width="1" height="4"/>
    <rect x="12" y="15" width="4" height="1"/>
    <rect x="4" y="4" width="8" height="2"/>
    <rect x="4" y="7" width="8" height="2"/>
    <rect x="4" y="10" width="8" height="2"/>
  </g> ]
  getViewBox = () => '0 0 16 16'
}
